import { get } from '@direct-frontend/stdlib';

export const isErrorWithType = <T extends string = string>(
    error: unknown,
    codesMap?: Record<T, unknown>
): error is { responseData: { type: T } } => {
    const value = get(error, ['responseData', 'type']);
    const hasValue = typeof value === 'string';

    if (hasValue && codesMap) {
        return value in codesMap;
    }

    return hasValue;
};
